import { useAuth } from '../../../hooks/auth';
import { useCart } from '../../../hooks/cart';

import { Container, Content, ContentModal } from './styles';

type LojaData = {
	id: string;
	nome: string;
	url_avatar: string;
	url_page: string;
	fantazia: string;
	fone: string;
	endereco: {
		cep: string;
		uf: string;
		cid: string;
		cidcod: string;
		bai: string;
		endereco: string;
		num: string;
		comp: string;
		formatted_address: string;
		location: {
			lat: number;
			lng: number;
		};
	};
};
interface ModalDATA {
	onRequestClose: (close: boolean) => void;
  id?: string;
	selectLoja: LojaData;
};

const ModalTrocaLoja: React.FC<ModalDATA> = ({
  id = 'modalTrocaLoja',
	onRequestClose,
	selectLoja,
}) => {
  function handleOutSideClick(e: any) {
		if (e.target.id === id) {
			onRequestClose(false)
		}
  };

	const { company, setCompany } = useAuth();
  const { initCart } = useCart();

  function handleEsvaziarIncluir() {
		setCompany(selectLoja);
		initCart();
		onRequestClose(false);
	};

  return (
    <Container id="modalTrocaLoja" onClick={handleOutSideClick}>
      <Content>
        <ContentModal>
          <h2>Você só pode adicionar itens de uma loja por vez.</h2>
          <h3>Deseja esvaziar o carrinho e trocar de loja?</h3>
					<h3>de <span>"{company.fantazia}"</span> para <span>"{selectLoja.fantazia}"</span></h3>

          <button
            className="button-adicionar"
						onClick={handleEsvaziarIncluir}
          >
            Esvaziar carrinho e trocar
          </button>

					<button className="button-cancel" onClick={() => onRequestClose(false)}>
            Cancelar
          </button>
        </ContentModal>
      </Content>
    </Container>
  );
};

export default ModalTrocaLoja;
